import { PageTitle } from "./shared";

export const PageNotImplemented = ({ title }) => (
  <div>
    <PageTitle title={ title } />
    This page is not yet implemented.
  </div>
)
